import { render, staticRenderFns } from "./zhibiao-select.vue?vue&type=template&id=285d1dd6&"
import script from "./zhibiao-select.vue?vue&type=script&lang=ts&"
export * from "./zhibiao-select.vue?vue&type=script&lang=ts&"
import style0 from "./zhibiao-select.vue?vue&type=style&index=0&id=285d1dd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports